/**
 * @file Apiのライブラリコール用モジュール
 * @namespace ddv2.library.apis.business
 */

/**
 * @module kessanKikan
 */

import HttpClient from '@/rahmen/httpClient'

export default {
  /**
   * 対象日から自社日付取扱情報を考慮した年度を取得
   * @param {String} date 対象日
   * @param {String} month 決算月
   * @param {String} day 締め日
   * @param {String} kbn 当月基準区分
   * @returns {Promise}
   * @example
   * ApiLibrary.calcNendoByDate('2021/03/19', '12', '99', '01').then(data => {
   *   this.hoge = data.payload
   * }
   */
  calcNendoByDate: function (date, month, day, kbn) {
    var httpClient = new HttpClient()
    return httpClient.get(`/api/v1/apilibrary/calculatenendo?date=${date}&kessanMonth=${month}&shimeDay=${day}&togetsuKijyunKbn=${kbn}`)
  },
  /**
   * 対象年から自社日付取扱情報を考慮した開始日と終了日を取得
   * @param {String} nendo 対象年
   * @param {String} month 決算月
   * @param {String} day 締め日
   * @param {String} kbn 当月基準区分
   * @returns {Promise}
   * @example
   * ApiLibrary.calculateNendoKikan('2021', '12', '99', '01').then(data => {
   *   this.start = data.payload.item1
   *   this.end = data.payload.item2
   * }
   */
  calculateNendoKikan: function (nendo, month, day, kbn) {
    var httpClient = new HttpClient()
    return httpClient.get(`/api/v1/apilibrary/calculatenendokikan?nendo=${nendo}&kessanMonth=${month}&shimeDay=${day}&togetsuKijyunKbn=${kbn}`)
  }
}
